module.exports = function (e) {
  var r = {};

  function n(t) {
    if (r[t]) return r[t].exports;
    var o = r[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return e[t].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = r, n.d = function (e, r, t) {
    n.o(e, r) || Object.defineProperty(e, r, {
      enumerable: !0,
      get: t
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, r) {
    if (1 & r && (e = n(e)), 8 & r) return e;
    if (4 & r && "object" == typeof e && e && e.__esModule) return e;
    var t = Object.create(null);
    if (n.r(t), Object.defineProperty(t, "default", {
      enumerable: !0,
      value: e
    }), 2 & r && "string" != typeof e) for (var o in e) {
      n.d(t, o, function (r) {
        return e[r];
      }.bind(null, o));
    }
    return t;
  }, n.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(r, "a", r), r;
  }, n.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, n.p = "", n(n.s = 3);
}([function (e, r) {
  e.exports = require("react");
}, function (e, r) {
  e.exports = require("classnames");
}, function (e, r, n) {
  "use strict";

  n.r(r), n.d(r, "createBurger", function () {
    return s;
  });
  var t = n(0),
      o = n.n(t),
      u = n(1),
      a = n.n(u);
  n(8);

  function c() {
    return (c = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var n = arguments[r];

        for (var t in n) {
          Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function i(e, r, n) {
    return r in e ? Object.defineProperty(e, r, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = n, e;
  }

  function l(e, r) {
    if (null == e) return {};

    var n,
        t,
        o = function (e, r) {
      if (null == e) return {};
      var n,
          t,
          o = {},
          u = Object.keys(e);

      for (t = 0; t < u.length; t++) {
        n = u[t], r.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }(e, r);

    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);

      for (t = 0; t < u.length; t++) {
        n = u[t], r.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }

  var f = function f(e) {
    var r = e.className,
        n = e.Component,
        t = e.isOpen,
        u = e.direction,
        f = void 0 === u ? null : u,
        s = l(e, ["className", "Component", "isOpen", "direction"]);
    return o.a.createElement(n, c({
      className: a()("burger", r, i({
        open: t
      }, "burger-".concat(f), f))
    }, s), o.a.createElement("div", {
      className: "burger-lines"
    }));
  };

  f.defaultProps = {
    className: null,
    Component: "div",
    isOpen: !1,
    direction: null
  };

  var s = function s(e) {
    return function (r) {
      var n = r.className,
          t = r.direction,
          u = l(r, ["className", "direction"]);
      return o.a.createElement(f, c({
        className: a()(e, n, i({}, "burger-".concat(t), t))
      }, u));
    };
  };

  r.default = f;
}, function (e, r, n) {
  "use strict";

  n.r(r);
  n(13);
  var t = n(2);
  r.default = Object(t.createBurger)("burger-squeeze");
},,,,, function (e, r) {},,,,, function (e, r) {}]);